var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "27px",
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01---Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01---Home-",
    transform: "translate(-1330.000000, -83.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1330.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.935483871,
    x2: 28.6258065,
    y2: 0.935483871,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12.816129,
    x2: 28.6258065,
    y2: 12.816129,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 24.6967742,
    x2: 28.6258065,
    y2: 24.6967742,
    id: "Stroke-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtMenu);
export default __webpack_public_path__ + "static/media/bt-menu.e74aeda8594a7ecfc318e329d43d05c1.svg";
export { ForwardRef as ReactComponent };